import { api } from '../lib/api.js';
import type { LiveWorksiteRow } from '@attendance/shared';

/**
 * Real-time per-site headcount board. Distinct from the per-worker live board
 * (`live.api.ts`): this groups everyone currently on-site BY worksite, with
 * since-when / on-site-duration and long-stay / over-capacity flags. Role-scoped
 * server-side (ADMIN/HR all worksites, MANAGER only sites where their direct
 * reports are on-site). Response is `{ data: LiveWorksiteRow[] }`.
 */
/**
 * The ONE query key the per-site live headcount is registered under.
 *
 * Exported because two surfaces now read this feed — the Operations control
 * room's "On site now" figure and the rail's live count beside the Operations
 * row — and rule 3.2 (one roster, one scale) is only structural if the two are
 * literally the same cache entry. Hand-writing the array in the second place is
 * how the rail and the page come to state different numbers about the same
 * minute, which is the harder of the two to notice.
 */
export const LIVE_HEADCOUNT_QUERY_KEY = ['site-ops', 'live-headcount'] as const;

export const liveSiteBoardApi = {
  liveHeadcount: (): Promise<LiveWorksiteRow[]> =>
    api
      .get<{ data: LiveWorksiteRow[] }>('/site-ops/live-headcount')
      .then((r) => r.data),
};
